import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/jenkins-agent/workspace/build-csrb-nma-chat-ui_PR-1101/app/components/ClientProvidersWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/jenkins-agent/workspace/build-csrb-nma-chat-ui_PR-1101/app/components/ClientScripts.tsx");
;
import(/* webpackMode: "eager" */ "/var/lib/jenkins/jenkins-agent/workspace/build-csrb-nma-chat-ui_PR-1101/app/styles/globals.scss");
